module.exports = __webpack_public_path__ + "img/authorization-error.a5969043.svg";